import * as React from 'react';

import {Body} from 'shells/typography/body';
import {SectionLabel} from 'shells/typography/section-label';

import type {QuoteDisplayStatus} from 'nutshell-graphql-types';

type Props = {
    completionComment: string;
    displayStatus: QuoteDisplayStatus;
};

export function CompletionComment(props: Props) {
    const label = props.displayStatus === 'ACCEPTED' ? 'Payment comments' : 'Reason for voiding';

    return (
        <div className='pt-16 pb-32'>
            <SectionLabel noBottomBorder={true}>{label}</SectionLabel>
            <Body size='small'>{props.completionComment}</Body>
        </div>
    );
}
